import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ShopGridStandardViewModel from "../viewModel";
import { truncate } from "../../../helpers/generalHelper";

const ShopSearchHistory = () => {
  const { t } = useTranslation();
  const [searchHistory, setSearchHistory] = useState();
  const [searchHistoryList, setSearchHistoryList] = useState();
  const {
    setRefreshSearchHistoryList,
    refreshSearchHistoryList,
    setSearchFilters,
    searchFilters,
    onClickDeleteRecord,
  } = useContext(ShopGridStandardViewModel.Context);

  const onClickRecord = (searchValue) => {
    setSearchFilters({
      ...searchFilters,
      _sort: "-updatedAt",
      _page: 1,
      name: searchValue,
    });
  };

  useEffect(() => {
    setSearchHistory(localStorage.getItem("searchKeywordHistory"));
  }, []);

  useEffect(() => {
    setSearchHistory(localStorage.getItem("searchKeywordHistory"));
    setRefreshSearchHistoryList(false);
  }, [refreshSearchHistoryList]);

  useEffect(() => {
    setSearchHistoryList(
      searchHistory && JSON.parse(searchHistory).reverse().slice(0, 10)
    );
  }, [searchHistory]);

  return (
    <div className="sidebar-widget">
      <h4 className="pro-sidebar-title">{t("searchHistory")}</h4>
      <div className="sidebar-widget-list mt-30 mb-30">
        {searchHistoryList && (
          <ul>
            {Array.isArray(searchHistoryList) &&
              searchHistoryList.map((record) => (
                <li>
                  <div
                    className="sidebar-widget-list-left"
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    <button
                      className="toggle-title"
                      style={{ width: 200, textTransform: "unset" }}
                      onClick={() => onClickRecord(record)}
                    >
                      {truncate(record, 20)}
                    </button>
                    <button
                      className="toggle-title"
                      style={{ width: "auto", padding: 0, marginLeft: 10 }}
                      onClick={() => onClickDeleteRecord(record)}
                    >
                      -
                    </button>
                  </div>
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ShopSearchHistory;
